import { ROOT_MEDIA } from 'shared-base';

export const loadModelAndWait = (id: string) =>
  new Promise<void>((resolve) => {
    const check = setInterval(() => {
      const glbUrl = `${ROOT_MEDIA}/glbs/${id}.glb`;
      fetch(glbUrl, { method: 'HEAD' })
        .then((res) => {
          if (res.ok) {
            clearInterval(check);
            resolve();
          }
        })
        .catch(() => {});
    }, 500);
  });

export const delay = (ms: number) => new Promise((r) => setTimeout(r, ms));

export const downloadDataUrl = (dataUrl: string, filename: string) => {
  const a = document.createElement('a');
  a.href = dataUrl;
  a.download = filename;
  a.click();
};

export const recordVideo = (canvas: HTMLCanvasElement, filename: string, durationMs: number) =>
  new Promise<void>((resolve) => {
    const stream = canvas.captureStream(60); // 60 FPS
    const recorder = new MediaRecorder(stream);
    const chunks: Blob[] = [];

    recorder.ondataavailable = (e) => chunks.push(e.data);
    recorder.onstop = () => {
      const blob = new Blob(chunks, { type: 'video/webm' });
      const url = URL.createObjectURL(blob);
      downloadDataUrl(url, filename);
      resolve();
    };

    recorder.start();
    setTimeout(() => recorder.stop(), durationMs);
  });
